import { render, staticRenderFns } from "./checkSalesReturnsEdit_ec.vue?vue&type=template&id=2021c854&scoped=true&"
import script from "./checkSalesReturnsEdit_ec.vue?vue&type=script&lang=js&"
export * from "./checkSalesReturnsEdit_ec.vue?vue&type=script&lang=js&"
import style0 from "./checkSalesReturnsEdit_ec.vue?vue&type=style&index=0&id=2021c854&lang=less&scoped=true&"
import style1 from "./checkSalesReturnsEdit_ec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2021c854",
  null
  
)

component.options.__file = "checkSalesReturnsEdit_ec.vue"
export default component.exports